import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ActionCard } from "~/components/card/action-card";
import { IconName } from "~/components/icon/icon";
import { SearchFilterComparisonOperator } from "~/hooks/search/types";
import { routePath } from "~/shared/constants";
import { KebabCase } from "~/utils/types";
import { MetadataGapFilterName } from "./use-metadata-gap-counts";

export interface BacklistMetadataGapCardProps {
  filterName: MetadataGapFilterName;
  threshold: number;
  count: number;
  subtitle: string;
  iconName: KebabCase<IconName>;
  iconWrapperClassName: string;
  iconClassName: string;
}

export const BacklistMetadataGapCard = ({
  filterName,
  threshold,
  count,
  subtitle,
  iconName,
  iconWrapperClassName,
  iconClassName,
}: BacklistMetadataGapCardProps) => {
  const { t } = useTranslation(["home"]);
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate({
      to: "/books",
      search: {
        filter: `${filterName}.${SearchFilterComparisonOperator.LESS}.${threshold}`,
      },
      state: { from: routePath("/"), openFilters: true },
    });
  };

  return (
    // ActionCard joins sibling cards into a stack; the wrapper keeps grid cells apart.
    <div>
      <ActionCard
        title={t("home:metadataGaps.books", { count })}
        subtitle={subtitle}
        iconName={iconName}
        iconWrapperClassName={iconWrapperClassName}
        iconClassName={iconClassName}
        onClick={handleNavigate}
        testId={`metadata-gap-${filterName}`}
      >
        <ActionCard.Action
          iconName="arrow-right"
          label={t("home:metadataGaps.viewBooks")}
          onClick={handleNavigate}
        />
      </ActionCard>
    </div>
  );
};
